import moment from 'moment';

const utcToLocal = (utcDate) => {
  if (utcDate === null) {
    return null;
  }
  const gmtDateTime = moment.utc(utcDate, 'YYYY-MM-DD hh:mm:ss A');
  return gmtDateTime.local();
};

export { utcToLocal };
